import React from 'react'

const Coupons = () => {
  return (
    <div className='w-full h-[calc(90vh-2.4rem)] bg-white rounded-xl shadow-lg flex flex-col items-center justify-center'>
      <h1 className='text-center'>Coupons Page!</h1>
    </div>
  )
}

export default Coupons
